import { connect } from 'react-redux';
import { Button } from 'legacy/components/Button';
import HC_CONSTANTS from 'HC_CONSTANTS';
import { getSubjectAddressId } from 'selectors/subject.selectors';
import { useListings } from 'src/lib/property-lookup/hooks/useListings';
import { OfferNowButton as theme } from 'legacy/css-modules';

const mapStateToProps = (state) => {
  return {
    addressId: getSubjectAddressId(state)
  };
};

const USE_LISTINGS_OPTIONS = { type: 'latestListing', salesOnly: true };

const OfferNowButton = ({ addressId }) => {
  const { data: listings, loading: isListingsLoading } = useListings(
    addressId,
    USE_LISTINGS_OPTIONS
  );
  const latestListing = listings?.[0];
  const latestListingStatus = latestListing?.listingStatus.MlsState || '';
  const isActiveOrPending =
    latestListingStatus.toLowerCase() === 'active' ||
    latestListingStatus.toLowerCase() === 'pending';

  if (isListingsLoading || !isActiveOrPending) {
    return null;
  }

  const url = `${HC_CONSTANTS.HCS_PLATFORM_URL}/pexp/offer?hc_address_id=${addressId}`;

  return (
    <Button
      className={theme.OfferNowButton}
      label="Offer Now"
      dataHcName="offer-now-button"
      href={url}
      target="_blank"
      rel="noreferrer"
    />
  );
};

export default connect(mapStateToProps)(OfferNowButton);
